<script setup lang="ts">
import { computed } from 'vue'

import {
  DataVisible,
  type DataVisibleProps,
  type SectionDataVisibleConfig,
} from '@/features/reports'
import { useI18n } from '@/shared/i18n'

const props = defineProps<{
  config: SectionDataVisibleConfig
  defaultPostData: string
}>()
const { t } = useI18n()

const dataVisibleProps = computed<DataVisibleProps>(() => {
  const { scheduleTabs: _scheduleTabs, ...config } = props.config
  return {
    ...config,
    defaultPostData: props.defaultPostData,
    ariaLabel: t('commerceAnalytics.appAcquisition.overview.title'),
    emptyLabel: t('reports.section.empty'),
    errorLabel: t('reports.section.error'),
    retryLabel: t('reports.section.retry'),
  } as DataVisibleProps
})
</script>

<template>
  <DataVisible v-bind="dataVisibleProps" />
</template>
